import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["drawer", "overlay"]

  connect() {
    // Initialize drawer state
    this.isOpen = false
    
    // Handle clicks outside drawer
    document.addEventListener('click', this.handleOutsideClick.bind(this))
  }

  disconnect() {
    document.removeEventListener('click', this.handleOutsideClick.bind(this))
  }

  toggle() {
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.isOpen = true
    this.drawerTarget.classList.remove('-translate-x-full')
    this.overlayTarget.classList.remove('hidden')
  }

  close() {
    this.isOpen = false
    this.drawerTarget.classList.add('-translate-x-full')
    this.overlayTarget.classList.add('hidden')
  }

  handleOutsideClick(event) {
    if (this.isOpen && !this.drawerTarget.contains(event.target) && 
        !event.target.closest('[data-drawer-toggle]')) {
      this.close()
    }
  }
}